
const IndonesiaFlag = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="17" viewBox="0 0 22 17" fill="none">
            <rect x="0.25" y="0.75" width="21.5" height="15.5" rx="1.75" fill="white" stroke="#F5F5F5" strokeWidth="0.5" />
            <mask id="mask0_1325_7445" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="17">
                <rect x="0.25" y="0.75" width="21.5" height="15.5" rx="1.75" fill="white" stroke="white" strokeWidth="0.5" />
            </mask>
            <g mask="url(#mask0_1325_7445)">
                <path fillRule="evenodd" clipRule="evenodd" d="M0 9.03333H22V0.5H0V9.03333Z" fill="#E12237" />
            </g>
        </svg>
    )
}

export default IndonesiaFlag